<template>
  <v-card class="mx-5 mb-6" max-width="100%">
    <v-card-title
      class="grey--text text--darken-2 font-weight-medium text-body-1"
    >
      {{ $t("common.setting") }}
    </v-card-title>
    <v-card-text>
      <div class="mb-9">
        <div class="grey--text text--darken-2 font-weight-medium mb-2">
          {{ $t("licenseLimiterSettings.notifyUsersTitle") }}
        </div>
        <span>
          {{ $t("licenseLimiterSettings.notifyUsersDescription") }}
        </span>
        <v-data-table
          :headers="notifyUsersHeaders"
          :items="licenseLimiterSettings.notify_users || []"
          dense
          hide-default-footer
          hide-default-header
          class="elevation-0"
        >
          <template v-slot:item.email="{ item }">
            <v-list-item class="px-0">
              <v-list-item-avatar>
                <v-avatar color="accent" size="32">
                  <span class="white--text">
                    {{ item.email ? item.email.charAt(0).toUpperCase() : "?" }}
                  </span>
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-subtitle class="text-no-wrap">
                  {{ item.email }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>

          <!-- <template v-slot:item.actions="{ item }">
            <v-list-item-action>
              <v-btn text small color="error" @click="removeNotifyUser(item)">
                {{ $t("common.remove") }}
              </v-btn>
            </v-list-item-action>
          </template> -->
        </v-data-table>
        <!-- <v-btn
            color="accent"
            class="mt-3"
            elevation="0"
            >Adicionar usuário</v-btn
          > -->
      </div>

      <div>
        <div class="grey--text text--darken-2 font-weight-medium mb-2">
          {{ $t("licenseLimiterSettings.automaticActionTitle") }}
        </div>
        <div class="grey--text text--darken-2 mb-3">
          {{ $t("licenseLimiterSettings.automaticActionDescription") }}
        </div>

        <div>
          <div class="d-flex mb-5">
            <div class="d-flex align-center" style="min-width: 250px">
              <div>{{ $t("licenseLimiterSettings.removeLicense") }}</div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="accent"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    v-text="'ph-question'"
                    class="ml-2"
                    size="20"
                  />
                </template>
                <span>{{
                  $t("licenseLimiterSettings.removeLicenseTooltip")
                }}</span>
              </v-tooltip>
            </div>

            <div class="d-flex align-center flex-grow-1 justify-start">
              <v-switch
                color="accentSuite"
                inset
                hide-details
                v-model="localRemoveLicenseActive"
                :disabled="loading"
                class="mt-0 pt-0"
              />
              <span>
                {{
                  localRemoveLicenseActive
                    ? $t("common.activated")
                    : $t("common.deactivated")
                }}
              </span>
            </div>
          </div>

          <!-- <div class="d-flex">
            <div class="d-flex align-center" style="min-width: 250px">
              <div>{{ $t("licenseLimiterSettings.suspendUser") }}</div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="accent"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    v-text="'ph-question'"
                    class="ml-2"
                    size="20"
                  />
                </template>
                <span>{{
                  $t("licenseLimiterSettings.suspendUserTooltip")
                }}</span>
              </v-tooltip>
            </div>

            <div class="d-flex align-center flex-grow-1 justify-start">
              <v-switch
                color="accentSuite"
                inset
                hide-details
                v-model="suspendUserActive"
                :disabled="loading"
                class="mt-0 pt-0"
              />
              <span>
                {{
                  suspendUserActive
                    ? $t("common.activated")
                    : $t("common.deactivated")
                }}
              </span>
            </div>
          </div> -->

          <div class="mt-9">
            <v-btn
              color="accent"
              elevation="0"
              :disabled="loading || !isDirty"
              :loading="loading"
              @click="saveSettings"
            >
              {{ $t("common.save") }}
            </v-btn>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex/dist/vuex.common.js";

export default {
  name: "ConfigurationLicenseLimiterCard",
  data() {
    return {
      loading: false,
      localRemoveLicenseActive: false,
    };
  },
  computed: {
    ...mapGetters(["licenseLimiterSettings"]),
    notifyUsersHeaders() {
      return [
        { value: "email", text: "", sortable: false, align: "start" },
        {
          value: "actions",
          text: "",
          sortable: false,
          align: "end",
          width: 120,
        },
      ];
    },
    originalRemoveLicenseActive() {
      return this.licenseLimiterSettings
        ? this.licenseLimiterSettings.remove_license
        : false;
    },
    isDirty() {
      return this.localRemoveLicenseActive !== this.originalRemoveLicenseActive;
    },
  },
  watch: {
    licenseLimiterSettings: {
      handler(val) {
        this.localRemoveLicenseActive = val ? val.remove_license : false;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions(["updateLicenseLimiterSettings"]),
    async saveSettings() {
      if (!this.isDirty) return;
      this.loading = true;
      try {
        const payload = {
          remove_license: this.localRemoveLicenseActive,
        };
        await this.updateLicenseLimiterSettings(payload);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
